import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './Drawer.module.scss'

const DrawerSection = ({ title, hint, children }) => (
  <section>
    <div className='d-flex align-items-baseline justify-content-between mb-2'>
      <h6 className={classNames(classes.sectionTitle, 'mb-0')}>{title}</h6>
      {hint && <span className={classes.sectionHint}>{hint}</span>}
    </div>
    <div className={classNames(classes.sectionBody, 'd-flex flex-column')}>{children}</div>
  </section>
)

DrawerSection.propTypes = {
  title: PropTypes.string.isRequired,
  hint: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default DrawerSection
